import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
//@ts-ignore
import { removeParam, setParam } from "@utils/UrlBuilderUtils";
export var handleBreadcrumbLinkClick = function handleBreadcrumbLinkClick(_ref) {
  var target = _ref.target;
  var _a;
  var targetEl = target;
  if (!targetEl || targetEl.classList.contains("disabled")) return;
  var URL = (_a = targetEl.getAttribute("data-href")) !== null && _a !== void 0 ? _a : targetEl.getAttribute("href");
  // Niccolò: if search is not empty, force param page to 1 when change place
  if (window.location.search) {
    var newURL = URL + setParam("p", "1", window.location.search);
    URL = removeParam("zoneID", newURL);
  }
  if (URL) window.location.href = URL;
};